import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { OfferVitrineService } from '../../../services/offer-vitrine.service';
import { select, Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { RefillPassOptionInterface } from '../../../models/refill-pass-option.interface';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { PaymentDetailsInterface } from '../../../models/payment-details.interface';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { ECardsActions, GetCardsSuccess } from '../../../../account/store/actions/cards.actions';
import { Actions, ofType } from '@ngrx/effects';
import { CardInterface } from '../../../../account/models/card.interface';
import { SaveMission } from '../../../store/actions/mission.actions';
import { RefillOfferInterface } from '../../../models/refill-offer.interface';
import { ConsumptionInterfaceState } from '../../../../lines/store/state/consumption.state';
import { AlertMessageInterface } from '../../../models/alert-message.interface';
import { GetAlertMessage } from '../../../store/actions/alert-message.actions';
import moment from 'moment';

@Component({
  selector: 'app-refill-or-pass',
  templateUrl: './refill-or-pass.component.html',
  styleUrls: ['./refill-or-pass.component.css'],
  standalone: false
})
export class RefillOrPassComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  customer: CustomerInterface;

  readonly refillChoice = 'refill';
  readonly passChoice = 'pass';
  readonly offerChoice = 'offer';
  readonly prepaidOfferCategory = 'offres-prépayées';
  choice: string|null;
  selectedPaymentMethod: string;
  options: Array<RefillPassOptionInterface>;
  offers: Array<RefillOfferInterface>;
  checkedItems: Array<{ id: number; price: number; }>;
  step: number;
  cards: Array<CardInterface>;
  selectedCard: CardInterface|null;
  rateLimitErrorMessage: string|null;
  defaultRechargeOption: number|null;
  displayCountries: boolean;
  displayPromoAlgeria: boolean;
  walletValue: number;
  paymentDetailsInterface = {
    errorMessage: 'Votre paiement a été annulé ou refusé.',
    externalId: null,
    redirectLink: null,
    type: 'refill_or_pass',
    procedureType: null,
    procedureCode: ConstsHelper.PROCEDURE_REFILL_OR_PASS,
    selectedLine: null,
    payload: {},
    amount: 0,
  } as PaymentDetailsInterface;
  refillLabel: string;

  constructor(
      private offerVitrineService: OfferVitrineService,
      private actions$: Actions,
      private store: Store<any>
  ) {}

  ngOnInit() {
    this.step = 1;
    this.displayCountries = false;
    this.displayPromoAlgeria = true;
    this.defaultRechargeOption = null;
    if (localStorage.getItem(ConstsHelper.LOCAL_STORAGE_SELECTED_RECHARGE_OPTION)) {
      this.defaultRechargeOption = Number(localStorage.getItem(ConstsHelper.LOCAL_STORAGE_SELECTED_RECHARGE_OPTION));
      localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_SELECTED_RECHARGE_OPTION);
      this.setChoice(this.refillChoice);
    }
    this.walletValue = 0;
    this.choice = null;
    this.rateLimitErrorMessage = null;
    this.selectedPaymentMethod = null;
    this.selectedCard = null;
    this.cards = [];
    this.options = [];
    this.checkedItems = [];
    this.paymentDetailsInterface.selectedLine = this.line;
    this.actions$.pipe(ofType(ECardsActions.GetCardsSuccess)).subscribe((result: GetCardsSuccess) => {
      if (null != result.payload) {
        this.cards = result.payload;
        if (this.cards.length > 0) {
          this.selectedPaymentMethod = 'cb_payment_recurrent';
          const selectedCardIndex = this.cards.findIndex(card => card.isSelected === true);
          if (selectedCardIndex === -1) {
            this.selectedCard = this.cards[0];
          } else {
            this.selectedCard = this.cards[selectedCardIndex];
          }
        }
      }
    });
    this.store.pipe(select(ConstsHelper.REDUCER_CONSUMPTION)).subscribe((response: ConsumptionInterfaceState) => {
      if (!(response.consumption instanceof Array) && null !== response.consumption && response.consumption.counters) {
        for (const counter of response.consumption.counters) {
          if ([null, ''].indexOf(counter.value) === -1 && counter.label.toLowerCase() === 'wallet') {
            this.walletValue = Number(counter.value.replace(' ', '').replace('€', ''));
          }
        }
      }
    });
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setChoice(value: string|null) {
    const carrier = 'gsm';
    const channel = 'boutique_drapeau';
    this.rateLimitErrorMessage = null;
    this.displayPromoAlgeria = true;
    let packageType = value;
    if (value === this.passChoice) {
      packageType = 'option,promo_algerie';
    }
    if (
        this.line.offer.offer_category == this.prepaidOfferCategory ||
        (
            this.line.offer.offer_category !== this.prepaidOfferCategory &&
            value !== this.passChoice
        )
    ) {
      this.offerVitrineService.checkPackageRateLimit(this.line.phoneNumber, packageType).subscribe(
          rateLimitResponse => {
            if (rateLimitResponse.extra[0].rate_limit_reached !== 0) {
              this.rateLimitErrorMessage = 'Vous avez atteint votre limite de recharge.';
            } else {
              this.step = 2;
              this.choice = value;
              this.options = [];
              this.offers = [];
              this.checkedItems = [];
              switch (value) {
                case this.refillChoice:
                  this.offerVitrineService.getRefillOptions(carrier, channel, this.line.offer.id).subscribe(
                      response => {
                        this.options = response;
                        if (this.defaultRechargeOption) {
                          const optionIndex = this.options.findIndex(op => op.option_id === this.defaultRechargeOption);
                          if (optionIndex !== -1) {
                            this.setCheckedOption({target: {checked: true}}, this.options[optionIndex]);
                            this.setStep(3);
                          }
                        }
                      }
                  );
                  this.refillLabel = 'wallet';
                  break;
                case this.passChoice:
                  this.displayPromoAlgeria = rateLimitResponse.extra[1].rate_limit_reached === 0;
                  this.offerVitrineService.getPassOptions(carrier, channel, this.line.offer.id).subscribe(
                      response => {
                        this.options = response;
                      }
                  );
                  this.refillLabel = 'options';
                  break;
                case this.offerChoice:
                  this.offerVitrineService.getRefillOffers(this.line.offer.id).subscribe(
                      response => {
                        for (const offer of response) {
                          if (!offer.hidden) {
                            this.offers.push(offer);
                          }
                        }
                      }
                  );
                  this.refillLabel = 'forfait';
                  break;
              }
            }
          }, error => {
            this.rateLimitErrorMessage = 'Vous avez atteint votre limite de recharge.';
          }
      );
    } else {
      this.step = 2;
      this.choice = value;
      this.options = [];
      this.offers = [];
      this.checkedItems = [];
      this.offerVitrineService.getPassOptions(carrier, channel, this.line.offer.id).subscribe(
          response => {
            for (let opt of response) {
              if (this.line.options.findIndex(o => o.id == opt.option_id) === -1) {
                this.options.push(opt);
              }
            }
          }
      );
      this.refillLabel = 'options';
    }
  }

  setCheckedOption($event, item: RefillPassOptionInterface|RefillOfferInterface) {
    if ([this.refillChoice, this.offerChoice].indexOf(this.choice) !== -1) {
      this.checkedItems = [];
      if ($event.target.checked) {
        if ('option' in item) {
          this.checkedItems.push({id: item.option.option_id, price: Number(item.option.in_sale_ttc.toFixed(2))});
        } else {
          this.checkedItems.push({id: item.offer_id, price: item.base_price_ttc});
        }
      }
    } else if ('option' in item) {
      const itemIndex = this.checkedItems.findIndex((obj) => obj.id === item.option_id);
      if ($event.target.checked && itemIndex === -1) {
        this.checkedItems.push({id: item.option.option_id, price: Number(item.option.in_sale_ttc.toFixed(2))});
      }
      if (!$event.target.checked && itemIndex !== -1) {
        this.checkedItems.splice(itemIndex, 1);
      }
    }
    this.paymentDetailsInterface.externalId = this.line.phoneNumber + '|' + this.choice + '|' + this.line.offer.id + '|';
    this.paymentDetailsInterface.amount = 0;
    for (const op of this.checkedItems) {
      this.paymentDetailsInterface.externalId += op.id + '_';
      this.paymentDetailsInterface.amount += Number(op.price.toFixed(2));
    }
  }

  isChecked(item: RefillPassOptionInterface|RefillOfferInterface) {
    if ('option_id' in item) {
    return this.checkedItems.findIndex((obj) => obj.id === item.option_id) !== -1;
    } else {
      return this.checkedItems.findIndex((obj) => obj.id === item.offer_id) !== -1;
    }
  }

  setStep(step: number) {
    this.step = step;
    if (step === 1) {
      this.choice = null;
      this.refillLabel = null;
      this.options = [];
      this.checkedItems = [];
    }
  }

  setSelectedCard(event) {
    this.selectedCard = this.cards.find(card => card.externalId === event.target.value);
  }

  getCardCreationDate(cardDate: string) {
    return moment(cardDate, 'YYYY-MM-DD H:i').format('DD/MM/YYYY H:mm');
  }

  isEmpty(value: any) {
    return [null, undefined, ''].indexOf(value) !== -1;
  }

  setSelectedPaymentMethod(paymentMethod: string) {
    this.selectedPaymentMethod = paymentMethod;
    this.selectedCard = null;
  }

  save() {
    const optionIds = [];
    let offerId = null;
    if (this.choice !== this.offerChoice) {
      for (const op of this.checkedItems) {
        optionIds.push(op.id);
      }
    } else {
      offerId = this.checkedItems[0].id;
    }
    const data = {
      type: this.choice,
      phoneNumber: this.line.phoneNumber,
      optionIds,
      offerId,
      paymentMethodId: null,
      routeValue: this.selectedPaymentMethod,
    };
    if (this.selectedPaymentMethod === 'cb_payment_recurrent' && this.selectedCard === null) {
      const alertMessage = { message: 'Le choix de la CB est obligatoire', code: 400 } as AlertMessageInterface;
      this.store.dispatch(new GetAlertMessage(alertMessage));
    } else if (this.selectedPaymentMethod === 'cb_payment_recurrent' && this.selectedCard !== null) {
      data.paymentMethodId = this.selectedCard.externalId;
      this.store.dispatch(new SaveMission(data, this.procedureCode));
    } else {
      this.store.dispatch(new SaveMission(data, this.procedureCode));
    }
  }
}
